module.exports = __webpack_public_path__ + "img/mickey01.18d99afb.jpg";